<template>
    <div>
        <div class="container">
            <div class="card card-signin my-5">
                <div class="card-header">
                    <b-navbar toggleable="lg">
                        <b-navbar-brand href="#">
                            <img src="../assets/wispot_colorido.svg" alt="Wispot Logo" class="logo" />
                        </b-navbar-brand>
                        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                        <b-collapse id="nav-collapse" is-nav>
                            <b-navbar-nav>
                                <b-nav-item to="/access-locations">Onde me conectei</b-nav-item>
                                <b-nav-item to="/profile">Meus Dados</b-nav-item>
                            </b-navbar-nav>
                            <b-navbar-nav class="ml-auto">
                                <b-nav-item-dropdown right variant="outline-danger">
                                    <template v-slot:button-content>
                                        <b-avatar :src="guest.picture_url"></b-avatar> {{ guest.first_name }}
                                    </template>
                                    <b-dropdown-item to="/profile">
                                        <font-awesome-icon icon="user-lock" class="icon" /> Perfil
                                    </b-dropdown-item>
                                    <b-dropdown-item :to="{ name: 'protocols', params: { per_page: 10, page: 1 } }">
                                        <font-awesome-icon icon="tasks" class="icon" /> Protocolos
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        :to="{ name: 'activity-records', params: { per_page: 10, page: 1 } }">
                                        <font-awesome-icon icon="address-card" class="icon" /> Registro de atividades
                                    </b-dropdown-item>
                                    <b-dropdown-item to="/access-locations">
                                        <font-awesome-icon icon="map-marker-alt" class="icon" /> Onde me conectei
                                    </b-dropdown-item>
                                    <b-dropdown-item to="#" @click.prevent="lougout">
                                        <font-awesome-icon icon="sign-out-alt" class="icon" /> Sair
                                    </b-dropdown-item>
                                </b-nav-item-dropdown>
                            </b-navbar-nav>
                        </b-collapse>
                    </b-navbar>
                </div>
                <div class="card-body">
                    <slot></slot>
                </div>
                <b-card-footer>
                    <p class="text-center mt-3 mb-2 text-muted">Powered Wispot</p>
                </b-card-footer>
            </div>
        </div>
    </div>
</template>

<style scoped>
.container {
    width: 99%;
    max-width: 900px;
    min-height: 600px;
}

.container>.card>.card-body {
    min-height: 400px;
}

.logo {
    display: inline-block;
    width: 80px;
}

.card-signin {
    border: 0;
    border-radius: 1rem;
    box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
}

.card-signin .card-title {
    margin-bottom: 2rem;
    font-weight: 300;
    font-size: 1.5rem;
}

.card-signin .card-body {
    padding: 2rem;
}
</style>



<script>
import { mapActions, mapState } from 'vuex'

export default {
    onIdle() {
        this.lougout();
    },
    computed: {
        ...mapState('auth', ['guest'])
    },
    methods: {
        ...mapActions('auth', ['ActionSignOut']),
        lougout() {
            this.ActionSignOut();
            this.$router.push({ name: 'login' });
        }
    }
}
</script>
